__turbopack_context__.v({
  "icon-wrapper-circle": "styles-module__nO8uNG__icon-wrapper-circle",
  "item-link-span": "styles-module__nO8uNG__item-link-span",
  "search-result-card-wrapper-responsive": "styles-module__nO8uNG__search-result-card-wrapper-responsive",
  "search-result-shadow-box": "styles-module__nO8uNG__search-result-shadow-box",
  "text-content": "styles-module__nO8uNG__text-content",
});
